import script from "./TFooterActionsRight.vue?vue&type=script&setup=true&lang=ts"
export * from "./TFooterActionsRight.vue?vue&type=script&setup=true&lang=ts"

import "./TFooterActionsRight.vue?vue&type=style&index=0&id=64104bce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64104bce"]])

export default __exports__